import { defineComponent } from 'vue';

export const AppLayoutTabbed = defineComponent({
  name: 'AppLayoutTabbed',
  template: `
    <div class="app d-flex flex-column flex-nowrap h-100 overflow-hidden">
      <AppNavbar
        class="app__navbar flex-shrink-0"
        style="z-index: 1050; position: relative"
      />
      <div
        class="app__content flex-grow-1 bg-light position-relative overflow-hidden"
      >
        <ItpRouterTab
          home-route="/"
          home-title="Dashboard"
          home-icon="fa fa-home"
        />
      </div>
      <ItpModalHost />
    </div>
  `,
});

export default AppLayoutTabbed;
